import { gql } from '@apollo/client';

export const SAVE_SEARCH = gql`
  mutation SaveSearch($name: String!, $type: SavedSearchType!, $url: String!) {
    saveSearchV2(name: $name, type: $type, url: $url) {
      name
      url
      index
    }
  }
`;

export const GET_LOG_ENTRY = gql`
  query getFullLogEntry($continuationToken: String!) {
    getLogEntry(continuationToken: $continuationToken) {
      errorString
      logEntry {
        continuationToken
        logEntry {
          facetsNumberLimitExceeded
          facetsWithTruncatedValues
          parentTimestamps
          serverInfo
          sessionId
          severity
          threadId
          timestamp
          type
          values
        }
      }
      outcome
    }
  }
`;
